import React from 'react';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import RagAdminDashboard from '../components/RagAdmin/RagAdminDashboard';

const RagAdminDashboardContainer = (props) => (
  <ApolloProvider client={client}>
    <RagAdminDashboard {...props} />
  </ApolloProvider>
);

export default RagAdminDashboardContainer;
